var installedModules = {};
var moduleToHandlerMapping = {
	79998: {
		getter: () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	10288: {
		getter: () => (__webpack_require__.e("node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(40961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	57375: {
		getter: () => (__webpack_require__.e("node_modules_react-router-dom_esm_react-router-dom_js").then(() => (() => (__webpack_require__(58402))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	28458: {
		getter: () => (__webpack_require__.e("node_modules_loadable_component_dist_esm_loadable_esm_mjs").then(() => (() => (__webpack_require__(80243))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.16.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@loadable/component",
	}
};
var initialConsumes = [79998,10288,57375];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		79998
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		10288
	],
	"webpack_sharing_consume_default_react-router-dom_react-router-dom": [
		57375
	],
	"client_globals_js-node_modules_jquery_dist_jquery_js-node_modules_react-dom_client_js-webpack-ee07aa": [
		28458
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}